<div class="status-summary-dialog bpx-dialog bpx-dialog--wide">
  <h2 mat-dialog-title>Run Validity Status Details</h2>

  <mat-dialog-content>
  @if (!calResponseCombinedData.length) {
  <p class="bpx-empty">No status data available.</p>
  } @else {
  <div class="status-summary-table-wrap bpx-report" #statusSummaryScroll>
    <table #statusSummaryTable id="status-summary-table"
             class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head">
      <thead class="bpx-report__head">
        <tr>
          <td class="!align-middle">KitLot#</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"
                [ngClass]="getColumnClasses(materialItem)">
              {{ materialItem.reportContentItems.lot }}
              <ng-container *ngIf="materialItem.valueAssigned === 'AdjustedCalculate'">
                <span class="block">{{ adjustedLabel }}</span>
              </ng-container>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Instrument ID</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"
                [ngClass]="getColumnClasses(materialItem)">
              <span [class.mean-values-text]="isMeanColumnAssay(materialItem)">
                {{ isMeanColumnAssay(materialItem) ? 'Mean Values' : materialItem.reportContentItems.runId }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Assay Name</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"
                [ngClass]="getColumnClasses(materialItem)">
              {{ materialItem.reportContentItems.assay }}
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Bead Region</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"
                [ngClass]="getColumnClasses(materialItem)">
              {{ materialItem.reportContentItems.region }}
            </td>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Calibrator Specs Status</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.calibratorSpecStatus)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.calibratorSpecStatus) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Patient Sample Specs Status</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.patientSampleSpecStatus)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.patientSampleSpecStatus) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Patient Sample Acceptance Range</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.patientSampleAcceptanceRange)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.patientSampleAcceptanceRange) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Calibration Curve Validity</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.calCurveInformation?.calCurveValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.calCurveInformation?.calCurveValidity) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Calibration Replicate # Validity</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.calCurveInformation?.calReplicateValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.calCurveInformation?.calReplicateValidity) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Control Results Validity</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.controlResultsValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.controlResultsValidity) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Sample Replicate # Validity</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.sampleReplicateCountValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.sampleReplicateCountValidity) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Sample Replicate CV Validity</td>
          <ng-container *ngFor="let materialItem of calResponseCombinedData; trackBy: trackAssayRow;">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.sampleReplicateCVValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.sampleReplicateCVValidity) | uppercase }}
              </span>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
  }
  </mat-dialog-content>
</div>
